import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { NoAuthPageComponent } from 'shared/no-auth-page/no-auth-page.component'
import { sessionTokenGuard } from '../services/guards/session-token.guard'
import { LoginTwoFaComponent } from './login-two-fa/login-two-fa.component'
import { LoginComponent } from './login/login.component'
import { ResetPwdComponent } from './reset-pwd/reset-pwd.component'
import { SignupComponent } from './signup/signup.component'

const routes: Routes = [
  {
    path: '',
    component: NoAuthPageComponent,
    children: [
      { path: 'sign-in', component: LoginComponent },
      { path: 'reset-pwd', component: ResetPwdComponent },
      { path: 'signup', component: SignupComponent },
      {
        path: 'login-2fa',
        component: LoginTwoFaComponent,
        canActivate: [sessionTokenGuard],
      },
    ],
  },
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthRoutingModule {}
